/**
 * The old payment methods are sent so it's easier for data science to compare payment methods with our older data.
 *
 * @param {string} paymentId
 * @returns {string}
 */
import { getUnlocalizedPathFromRoute } from '@marketplace/helpers/router.js'

/**
 *
 * @param paymentId
 */
export function convertPaymentIdToMethod(paymentId) {
    return paymentId.split('-')[1]
}

/**
 * Parse the category path to an object with the category levels for Segment.
 *
 * @param {string} categoryPath
 * @returns {object}
 */
export function categoryPathMapping(categoryPath = '') {
    if (!categoryPath) {
        return null
    }

    const levels = {}

    const categories = categoryPath.split('/')

    categories.forEach((categorySlug, depth) => {
        levels[`level${depth + 1}Category`] = categorySlug
    })

    return {
        ...levels,
        level: categories.length,
    }
}

/**
 *
 * @param path
 */
export function pathToLevel(path) {
    const pathArray = getUnlocalizedPathFromRoute(path).split('/')

    return pathArray.length - 2
}

/**
 *
 * @param categoryPath
 */
export function categoryPathToDepth(categoryPath) {
    if (!categoryPath) {
        return null
    }

    const categories = categoryPath.split('/')

    return categories.length - 1
}
